export type SidebarCreateActionKind = 'document' | 'folder';

export type SidebarCreateAction = {
  kind: SidebarCreateActionKind;
  label: string;
  onSelect: () => void;
};

export function buildSidebarCreateActions({
  document,
  folder,
}: {
  document?: Omit<SidebarCreateAction, 'kind'>;
  folder?: Omit<SidebarCreateAction, 'kind'>;
}): SidebarCreateAction[] {
  return [
    ...(document
      ? [
          {
            kind: 'document' as const,
            ...document,
          },
        ]
      : []),
    ...(folder
      ? [
          {
            kind: 'folder' as const,
            ...folder,
          },
        ]
      : []),
  ];
}
